/**
 * Created by JasonChou on 16/12/2.
 */
import http from '../libs/http'

// 检查图片是否上传过
export const checkImage = (md5, projectId) => {
  return http.get({
    url: '/api/user/gallery',
    data: {
      params: {
        md5,
        projectId
      }
    }
  }).then((res) => {
    return res;
  })
};
// 上传图片新
export const uploadImageNew = (appId, projectId, md5, showName, bucketName, ext, bucketId, folderId ) => {
  return http.post({
    url: '/api/user/gallery',
    data: {
      appId,
      projectId,
      md5,
      showName,
      bucketName,
      ext,
      bucketId,
      folderId
    }
  }).then((res) => {
    return res;
  })
};

// 修改图片名称
export const editImageName = (projectId, _id, name) => {
  return http.put({
    url: '/api/user/gallery',
    data: {
      projectId,
      _id,
      name
    }
  }).then((res) => {
    return res;
  })
};

// 批量修改图片目标目录
export const editImageFloder = (projectId, imgIds, sourceFolderId, targetFolderId) => {
  return http.put({
    url: '/api/user/galleries',
    data: {
      projectId,
      imgIds,
      sourceFolderId,
      targetFolderId
    }
  }).then((res) => {
    return res;
  })
};
// 删除图片
export const delImage = (projectId, imgIds, folderId) => {
  return http.post({
    url: '/api/user/galleries',
    data: {
      projectId,
      imgIds,
      folderId
    }
  }).then((res) => {
    return res;
  })
};

// 获取文件夹目录
export const getFile = (projectId) => {
  return http.get({
    url: '/api/user/galleryFolders',
    data: {
      params: {
        projectId
      }
    }
  }).then((res) => {
    return res;
  })
};
// 根据目录id获取目录内图片
export const getFolderImage = (uuid, appId) => {
  return http.get({
    url: '/api/user/galleryFolder',
    data: {
      params: {
        uuid,
        appId
      }
    }
  }).then((res) => {
    return res;
  })
};

// 创建图库目录
export const creatFloder = (appId, name, projectId) => {
  return http.post({
    url: '/api/user/galleryFolder',
    data: {
      appId,
      name,
      projectId
    }
  }).then((res) => {
    return res;
  })
};

// 修改图库目录名称
export const editFloderName = (appId, uuid, name) => {
  return http.put({
    url: '/api/user/galleryFolder',
    data: {
      appId,
      uuid,
      name
    }
  }).then((res) => {
    return res;
  })
};
// 删除图库目录
export const delFloder = (appId, uuid, projectId) => {
  return http.delete({
    url: '/api/user/galleryFolder',
    data: {
      params: {
        appId,
        uuid,
        projectId
      }
    }
  }).then(res => {
    return res;
  })
};

export const savePageWidth = (app_id, page_id, screen_width) => {
  return http.post({
    url: '/api/page',
    data: {
      app_id,
      page_id,
      screen_width
    }
  }).then((res) => {
    return res;
  })
};

export const savePageHeight = (app_id, page_id, screen_height) => {
  return http.post({
    url: '/api/page',
    data: {
      app_id,
      page_id,
      screen_height
    }
  }).then((res) => {
    return res;
  })
};

export const getRoles = (app_id, offset, limit) => {
  return http.get({
    url: '/api/role',
    data: {
      params: {
        app_id,
        offset,
        limit
      }
    }
  }).then((res) => {
    return res;
  })
};

export const getOssAuth = (params) => {
  return http.get({
    url: '/api/ossAuth',
    data: {
      params,
    }
  }).then((res) => {
    return res;
  })
};

export const updateImage = (imageMeta) => {
  return http.post({
    url: '/api/user/gallery',
    data: imageMeta
  }).then((res) => {
    return res;
  });
};

export const getImages = (filterOpts) => {
  return http.get({
    url: '/api/user/gallery',
    data: {
      params: filterOpts
    }
  }).then((res) => {
    return res;
  })
};

export const shareImage = (images, type) => {
  // // console.log(images, type);
  return http.post({
    url: '/api/user/sys_gallery',
    data: {
      images,
      type
    }
  }).then((res) => {
    return res;
  })
};



// WEBPACK FOOTER //
// ./src/apis/common.js